import Api from '@/services/Api'

const HEADERURL = 'inv/devolucion_cliente/';
const ACCION_AGREGAR_DETALLE = 'agregar_detalle';
const ACTION_DELETE_DETAIL = 'eliminar_detalle';
const ACCION_GENERAR_NOTA = 'generar_nc';
const ACCION_CERRAR = 'cerrar';
const ACCION_ANULAR = 'anular';
const ACCION_ABRIR = 'abrir';
const ACCION_IMPRIMIR_PDF= 'pdf';

export default {

    fetch(params) {

        return Api().get(HEADERURL, {

            params: params

        });

    },

    getById(codigo) {

        return Api().get(`${HEADERURL}${codigo}`);

    },

    save(params) {
        if (params.id != null) {
            return Api().put(`${HEADERURL}${params.id}` + '/', params);
        }
        return Api().post(HEADERURL, params);

    },


    imprimir(id) {

        return Api().post(`${HEADERURL}${id}/${ACTION_IMPRIMIR}/`);

    },

    agregar_detalle(id, params) {
        return Api().post(`${HEADERURL}${id}/${ACCION_AGREGAR_DETALLE}/`, params);

    },

    eliminar_detalle(id, params) {

        return Api().post(`${HEADERURL}${id}/${ACTION_DELETE_DETAIL}/`, params);

    },
    generar_nc(id, params) {
        return Api().post(`${HEADERURL}${id}/${ACCION_GENERAR_NOTA}/`, params);

    },

    abrir(id) {

        return Api().post(`${HEADERURL}${id}/${ACCION_ABRIR}/`);

    },

    cerrar(id) {

        return Api().post(`${HEADERURL}${id}/${ACCION_CERRAR}/`);

    },

    anular(id) {

        return Api().post(`${HEADERURL}${id}/${ACCION_ANULAR}/`);

    },

    pdf(id, params) {

        return Api().post(`${HEADERURL}${id}/${ACCION_IMPRIMIR_PDF}/`, params);

    },


}